<template>
    <div v-if="null != pageList">
        <ExhibitorPage
            v-for="(v, i) in pageList"
            :key="i + '' + Math.random()"
            :cardList="v"
            :pageIndex="i + 1"
            @print-complete="printCallback"
        />
    </div>
</template>

<script setup>

import {onMounted, onBeforeMount, ref} from "vue";
import ExhibitorPage from "@/components/shopopee/print/format/exhibitor/exhibitorPage.vue";

const props = defineProps(["list"])
const emits = defineEmits(["print-complete"])

const pageCardNum = 9
const pageList = ref(null)
let lastPageNum = 0
const pageImgMap = {}


function fillPageList(){
    const pageNum = Math.ceil(props.list.length / pageCardNum)
    const dataList = []

    if (pageNum === 0){
        emits("print-complete", [])
    }

    lastPageNum = pageNum

    for (let i = 0; i < pageNum; i++){
        const currPageDataList = []
        let startIndex = i * pageCardNum
        let indexLimit = startIndex + pageCardNum
        indexLimit = indexLimit < props.list.length ? indexLimit : props.list.length

        for (let n = startIndex; n < indexLimit; n++){
            currPageDataList.push(props.list[n])
        }

        dataList.push(currPageDataList)
    }

    if (dataList.length === 0){
        emits("print-complete", [])
    }else{
        pageList.value = dataList
    }
}

function printCallback(url, index){
    pageImgMap[index] = url

    if (Object.keys(pageImgMap).length === lastPageNum){
        const imgTotalList = []

        for (let i = 1; i <= lastPageNum; i++){
            imgTotalList.push(pageImgMap[i])
        }

        emits("print-complete", imgTotalList)
    }
}

onBeforeMount(() => {
    if (null == props.list){
        emits("print-complete", [])
    }else{
        fillPageList()
    }
})

</script>

<style scoped>

</style>